import { c as _c } from "react-compiler-runtime";
import { useEffect } from 'react';
import { getErrorStatusCode } from 'framework-listing-lib/internal/utils/errors';
import { useGlobalError } from 'framework-listing-lib/internal/providers/DataProvider';
export default function useHandleDFCError(apolloError) {
  "use memo";

  const $ = _c(4);
  const [, setGlobalError] = useGlobalError();
  let t0;
  let t1;
  if ($[0] !== apolloError || $[1] !== setGlobalError) {
    t0 = () => {
      const statusCode = getErrorStatusCode(apolloError);
      if (statusCode) {
        setGlobalError({
          statusCode
        });
      }
    };
    t1 = [apolloError, setGlobalError];
    $[0] = apolloError;
    $[1] = setGlobalError;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
}